import MapLayerSwitch from './MapLayerSwitch'

export default MapLayerSwitch
